import { render, staticRenderFns } from "./ModalServiceContainer.vue?vue&type=template&id=07ab87c0&scoped=true&"
import script from "./ModalServiceContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalServiceContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalServiceContainer.vue?vue&type=style&index=0&id=07ab87c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ab87c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ab87c0')) {
      api.createRecord('07ab87c0', component.options)
    } else {
      api.reload('07ab87c0', component.options)
    }
    module.hot.accept("./ModalServiceContainer.vue?vue&type=template&id=07ab87c0&scoped=true&", function () {
      api.rerender('07ab87c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalServiceContainer.vue"
export default component.exports